import { IconButton } from "@hortis/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@hortis/ui/dropdown-menu";
import { Calendar, HelpCircle } from "@hortis/ui/icons";

export const HelpDropdown = () => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <IconButton
        ariaLabel="Help"
        className="absolute bottom-3 left-3 h-10 w-10 rounded-full font-medium shadow-md"
      >
        ?
      </IconButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      <DropdownMenuItem asChild>
        <a href="https://support.hortis.com/" target="_blank" rel="noreferrer">
          <HelpCircle className="h-4 w-4 text-grey-500" />
          Support
        </a>
      </DropdownMenuItem>
      <DropdownMenuItem asChild>
        <a href="https://hortis.com/changelog" target="_blank" rel="noreferrer">
          <Calendar className="h-4 w-4 text-grey-500" />
          Changelog
        </a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
